import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { Card } from "reactstrap";

import api from "../../services/api";
import { notify } from "../../utils/notify";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import FilterReportERP from "./FilterReportERP";
import {
  ReportERPContext,
  ReportERPContextProvider,
} from "../../context/ReportERPContext";
import MaskService from "../../utils/mask/maskService";

function createData(
  Empresa,
  ClienteCNPJ,
  Base,
  QtdClientes,
  QtdFornecedores,
  QtdProdutos,
  QtdPedidos,
  ValorPedidos,
  QtdNFe,
  ValorNFe,
  QtdNFSe,
  ValorNFSe,

  QtdBoletoRec,
  ValorBoletoRec,
  QtdCCreditoRec,
  ValorCCreditoRec,
  QtdCDebitoRec,
  ValorCDebitoRec,
  QtdDinheiroRec,
  ValorDinheiroRec,

  QtdBoletoPag,
  ValorBoletoPag,
  QtdCCreditoPag,
  ValorCCreditoPag,
  QtdCDebitoPag,
  ValorCDebitoPag,
  QtdDinheiroPag,
  ValorDinheiroPag,

  QtdRecebidos,
  ValorRecebidos,

  QtdPagos,
  ValorPagos
) {
  return {
    Empresa,
    ClienteCNPJ,
    Base,
    QtdClientes,
    QtdFornecedores,
    QtdProdutos,
    QtdPedidos,
    ValorPedidos,
    QtdNFe,
    ValorNFe,
    QtdNFSe,
    ValorNFSe,

    QtdBoletoRec,
    ValorBoletoRec,
    QtdCCreditoRec,
    ValorCCreditoRec,
    QtdCDebitoRec,
    ValorCDebitoRec,
    QtdDinheiroRec,
    ValorDinheiroRec,

    QtdBoletoPag,
    ValorBoletoPag,
    QtdCCreditoPag,
    ValorCCreditoPag,
    QtdCDebitoPag,
    ValorCDebitoPag,
    QtdDinheiroPag,
    ValorDinheiroPag,

    QtdRecebidos,
    ValorRecebidos,

    QtdPagos,
    ValorPagos,
  };
}

const headCells = [
  {
    name: "Empresa",
    numeric: false,
    label: "Empresa",
  },
  {
    name: "Base",
    checkbox: "Base",
    label: "Base",
  },
  {
    name: "QtdClientes",
    checkbox: "Clientes",
    label: "Qtd Clientes",
    align: "center",
  },
  {
    name: "QtdFornecedores",
    checkbox: "Fornecedores",
    label: "Qtd Fornecedores",
    align: "center",
  },
  {
    name: "QtdProdutos",
    checkbox: "Produtos",
    label: "Qtd Produtos",
    align: "center",
  },
  {
    name: "QtdPedidos",
    checkbox: "Pedidos",
    label: "Qtd Pedidos",
    align: "center",
  },
  {
    name: "ValorPedidos",
    checkbox: "Pedidos",
    label: "Valor Pedidos",
  },
  {
    name: "QtdNFe",
    checkbox: "NFe",
    label: "Qtd NFe",
    align: "center",
  },
  {
    name: "ValorNFe",
    checkbox: "NFe",
    label: "Valor NFe",
  },
  {
    name: "QtdNFSe",
    checkbox: "NFSe",
    label: "Qtd NFSe",
    align: "center",
  },
  {
    name: "ValorNFSe",
    checkbox: "NFSe",
    label: "Valor NFSe",
  },
  {
    name: "QtdBoletoRec",
    checkbox: "BoletoRec",
    label: "Qtd Boleto Rec.",
    align: "center",
  },
  {
    name: "ValorBoletoRec",
    checkbox: "BoletoRec",
    label: "Valor Boleto Rec.",
  },
  {
    name: "QtdCCreditoRec",
    checkbox: "CCreditoRec",
    label: "Qtd C.Crédito Rec.",
    align: "center",
  },
  {
    name: "ValorCCreditoRec",
    checkbox: "CCreditoRec",
    label: "Valor C.Crédito Rec.",
  },
  {
    name: "QtdCDebitoRec",
    checkbox: "CDebitoRec",
    label: "Qtd C.Débito Rec.",
    align: "center",
  },
  {
    name: "ValorCDebitoRec",
    checkbox: "CDebitoRec",
    label: "Valor C.Débito Rec.",
  },
  {
    name: "QtdDinheiroRec",
    checkbox: "DinheiroRec",
    label: "Qtd Dinheiro TRF. Rec.",
    align: "center",
  },
  {
    name: "ValorDinheiroRec",
    checkbox: "DinheiroRec",
    label: "Valor Dinheiro TRF. Rec.",
  },
  {
    name: "QtdBoletoPag",
    checkbox: "BoletoPag",
    label: "Qtd Boleto Pag.",
    align: "center",
  },
  {
    name: "ValorBoletoPag",
    checkbox: "BoletoPag",
    label: "Valor Boleto Pag.",
  },
  {
    name: "QtdCCreditoPag",
    checkbox: "CCreditoPag",
    label: "Qtd C.Crédito Pag.",
    align: "center",
  },
  {
    name: "ValorCCreditoPag",
    checkbox: "CCreditoPag",
    label: "Valor C.Crédito Pag.",
  },
  {
    name: "QtdCDebitoPag",
    checkbox: "CDebitoPag",
    label: "Qtd C.Débito Pag.",
    align: "center",
  },
  {
    name: "ValorCDebitoPag",
    checkbox: "CDebitoPag",
    label: "Valor C.Débito Pag.",
  },
  {
    name: "QtdDinheiroPag",
    checkbox: "DinheiroPag",
    label: "Qtd Dinheiro TRF. Pag.",
    align: "center",
  },
  {
    name: "ValorDinheiroPag",
    checkbox: "DinheiroPag",
    label: "Valor Dinheiro TRF. Pag.",
  },
  {
    name: "QtdRecebidos",
    label: "Qtd Recebidos",
    align: "center",
  },
  {
    name: "ValorRecebidos",
    label: "Valor Recebidos",
  },
  {
    name: "QtdPagos",
    label: "Qtd Pagos",
    align: "center",
  },
  {
    name: "ValorPagos",
    label: "Valor Pagos",
  },
];

function EnhancedTableHead() {
  const { checkboxes } = useContext(ReportERPContext);

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => {
          if (
            checkboxes[headCell.checkbox] ||
            typeof checkboxes[headCell.checkbox] === "undefined"
          ) {
            return (
              <TableCell
                key={headCell.name}
                padding={"default"}
                align={headCell.align}
              >
                {headCell.label}
              </TableCell>
            );
          } else return null;
        })}
      </TableRow>
    </TableHead>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  row: {
    margin: "1px",
  },
}));

const View = () => {
  const {
    year,
    mounth,
    checkboxes,
    cnpj,
    base,
    typePromoter,
    fantasy,
    setValuesTable,
  } = useContext(ReportERPContext);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rows, setRows] = useState([]);
  const [allRows, setAllRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingFilter, setLoadingFilter] = useState(false);
  const [rowsFilter, setRowsFilter] = useState([]);
  const [totalAmountPaid, SetTotalAmountPaid] = useState(0);
  const [totalQtdtPaid, SetTotalQtdtPaid] = useState(0);
  const [totalAmountReceived, SetTotalAmountReceived] = useState(0);
  const [totalQtdReceived, SetTotalQtdReceived] = useState(0);

  const [totalValorBoletoRec, SetTotalValorBoletoRec] = useState(0);
  const [totalQtdBoletoRec, SetTotalQtdBoletoRec] = useState(0);

  const [totalValorCCreditoRec, SetTotalValorCCreditoRec] = useState(0);
  const [totalQtdCCreditoRec, SetTotalQtdCCreditoRec] = useState(0);

  const [totalValorCDebitoRec, SetTotalValorCDebitoRec] = useState(0);
  const [totalQtdCDebitoRec, SetTotalQtdCDebitoRec] = useState(0);

  const [totalValorDinheiroRec, SetTotalValorDinheiroRec] = useState(0);
  const [totalQtdDinheiroRec, SetTotalQtdDinheiroRec] = useState(0);

  const [totalValorBoletoPag, SetTotalValorBoletoPag] = useState(0);
  const [totalQtdBoletoPag, SetTotalQtdBoletoPag] = useState(0);

  const [totalValorCCreditoPag, SetTotalValorCCreditoPag] = useState(0);
  const [totalQtdCCreditoPag, SetTotalQtdCCreditoPag] = useState(0);

  const [totalValorCDebitoPag, SetTotalValorCDebitoPag] = useState(0);
  const [totalQtdCDebitoPag, SetTotalQtdCDebitoPag] = useState(0);

  const [totalValorDinheiroPag, SetTotalValorDinheiroPag] = useState(0);
  const [totalQtdDinheiroPag, SetTotalQtdDinheiroPag] = useState(0);

  const [totalValorPedidos, SetTotalValorPedidos] = useState(0);
  const [totalQtdPedidos, SetTotalQtdPedidos] = useState(0);

  const [totalValorNFe, SetTotalValorNFe] = useState(0);
  const [totalQtdNFe, SetTotalQtdNFe] = useState(0);

  const [totalValorNFSe, SetTotalValorNFSe] = useState(0);
  const [totalQtdNFSe, SetTotalQtdNFSe] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        let error = false;

        if (!mounth || !mounth.id) {
          notify("Selecione o mês.");
          error = true;
        }

        if (!year || !year.descricao) {
          notify("Selecione o ano.");
          error = true;
        }

        if (error) return setLoading(false);

        const { data: response } = await api.get(
          `relatorio/erp/mes/${mounth.id}/ano/${year.descricao}`
        );

        const employees = response.data.map((employee, index) => {
          return createData(
            employee.Empresa,
            employee.ClienteCNPJ,
            employee.Base,
            employee.QtdClientes,
            employee.QtdFornecedores,
            employee.QtdProdutos,
            employee.QtdPedidos,
            employee.ValorPedidos,
            employee.QtdNFe,
            employee.ValorNFe,
            employee.QtdNFSe,
            employee.ValorNFSe,

            employee.QtdBoletoRec,
            employee.ValorBoletoRec,
            employee.QtdCCreditoRec,
            employee.ValorCCreditoRec,
            employee.QtdCDebitoRec,
            employee.ValorCDebitoRec,
            employee.QtdDinheiroRec,
            employee.ValorDinheiroRec,

            employee.QtdBoletoPag,
            employee.ValorBoletoPag,
            employee.QtdCCreditoPag,
            employee.ValorCCreditoPag,
            employee.QtdCDebitoPag,
            employee.ValorCDebitoPag,
            employee.QtdDinheiroPag,
            employee.ValorDinheiroPag,

            employee.QtdRecebidos,
            employee.ValorRecebidos,

            employee.QtdPagos,
            employee.ValorPagos
          );
        });

        setValuesTable(response.data);
        setRows(employees);
        setRowsFilter(employees);
        setAllRows(response.data);
        setLoading(false);
      } catch (error) {
        console.error("ERROR: PreviewReportERP fetchData", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [mounth, year, setValuesTable]);

  useEffect(() => {
    try {
      setLoadingFilter(true);
      const newRowsFilter = [...allRows].filter((element) => {
        return (
          (!cnpj ||
            element.ClienteCNPJ.toString()
              .toLowerCase()
              .normalize("NFD")
              .replace(/[^a-z0-9]/gi, "")
              .indexOf(
                cnpj
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[^a-z0-9]/gi, "")
              ) !== -1) &&
          (!fantasy ||
            element.Empresa.toString()
              .toLowerCase()
              .normalize("NFD")
              .replace(/[^a-z0-9]/gi, "")
              .indexOf(
                fantasy
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[^a-z0-9]/gi, "")
              ) !== -1) &&
          (!base ||
            element.Base.toString()
              .toLowerCase()
              .normalize("NFD")
              .replace(/[^a-z0-9]/gi, "")
              .indexOf(
                base
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[^a-z0-9]/gi, "")
              ) !== -1) &&
          (!typePromoter || element.IdTipoPromotor === typePromoter.Id)
        );
      });

      let totQtdRecebidos = 0;
      let totValorRecebidos = 0;

      let totQtdPagos = 0;
      let totValorPagos = 0;

      let totQtdPedidos = 0;
      let totValorPedidos = 0;

      let totQtdNFe = 0;
      let totValorNFe = 0;

      let totQtdNFSe = 0;
      let totValorNFSe = 0;

      let totQtdBoletoRec = 0;
      let totValorBoletoRec = 0;

      let totQtdCCreditoRec = 0;
      let totValorCCreditoRec = 0;

      let totQtdCDebitoRec = 0;
      let totValorCDebitoRec = 0;

      let totQtdDinheiroRec = 0;
      let totValorDinheiroRec = 0;

      let totQtdBoletoPag = 0;
      let totValorBoletoPag = 0;

      let totQtdCCreditoPag = 0;
      let totValorCCreditoPag = 0;

      let totQtdCDebitoPag = 0;
      let totValorCDebitoPag = 0;

      let totQtdDinheiroPag = 0;
      let totValorDinheiroPag = 0;

      newRowsFilter.forEach((element) => {
        totQtdPagos += element.QtdPagos;
        totValorPagos += parseFloat(element.ValorPagos);

        totQtdRecebidos += element.QtdRecebidos;
        totValorRecebidos += parseFloat(element.ValorRecebidos);

        totQtdPedidos += element.QtdPedidos || 0;
        totValorPedidos += parseFloat(element.ValorPedidos || 0);

        totQtdNFe += element.QtdNFe || 0;
        totValorNFe += parseFloat(element.ValorNFe || 0);

        totQtdNFSe += element.QtdNFSe || 0;
        totValorNFSe += parseFloat(element.ValorNFSe || 0);

        totQtdBoletoRec += element.QtdBoletoRec || 0;
        totValorBoletoRec += parseFloat(element.ValorBoletoRec || 0);

        totQtdCCreditoRec += element.QtdCCreditoRec || 0;
        totValorCCreditoRec += parseFloat(element.ValorCCreditoRec || 0);

        totQtdCDebitoRec += element.QtdCDebitoRec || 0;
        totValorCDebitoRec += parseFloat(element.ValorCDebitoRec || 0);

        totQtdDinheiroRec += element.QtdDinheiroRec || 0;
        totValorDinheiroRec += parseFloat(element.ValorDinheiroRec || 0);

        totQtdBoletoPag += element.QtdBoletoPag || 0;
        totValorBoletoPag += parseFloat(element.ValorBoletoPag || 0);

        totQtdCCreditoPag += element.QtdCCreditoPag || 0;
        totValorCCreditoPag += parseFloat(element.ValorCCreditoPag || 0);

        totQtdCDebitoPag += element.QtdCDebitoPag || 0;
        totValorCDebitoPag += parseFloat(element.ValorCDebitoPag || 0);

        totQtdDinheiroPag += element.QtdDinheiroPag || 0;
        totValorDinheiroPag += parseFloat(element.ValorDinheiroPag || 0);
      });

      SetTotalQtdtPaid(totQtdPagos);
      SetTotalAmountPaid(totValorPagos.toFixed(2));

      SetTotalQtdBoletoRec(totQtdBoletoRec);
      SetTotalValorBoletoRec(totValorBoletoRec.toFixed(2));

      SetTotalQtdPedidos(totQtdPedidos);
      SetTotalValorPedidos(totValorPedidos.toFixed(2));

      SetTotalQtdNFe(totQtdNFe);
      SetTotalValorNFe(totValorNFe.toFixed(2));

      SetTotalQtdNFSe(totQtdNFSe);
      SetTotalValorNFSe(totValorNFSe.toFixed(2));

      SetTotalQtdCCreditoRec(totQtdCCreditoRec);
      SetTotalValorCCreditoRec(totValorCCreditoRec.toFixed(2));

      SetTotalQtdCDebitoRec(totQtdCDebitoRec);
      SetTotalValorCDebitoRec(totValorCDebitoRec.toFixed(2));

      SetTotalQtdDinheiroRec(totQtdDinheiroRec);
      SetTotalValorDinheiroRec(totValorDinheiroRec.toFixed(2));

      SetTotalQtdBoletoPag(totQtdBoletoPag);
      SetTotalValorBoletoPag(totValorBoletoPag.toFixed(2));

      SetTotalQtdCCreditoPag(totQtdCCreditoPag);
      SetTotalValorCCreditoPag(totValorCCreditoPag.toFixed(2));

      SetTotalQtdCDebitoPag(totQtdCDebitoPag);
      SetTotalValorCDebitoPag(totValorCDebitoPag.toFixed(2));

      SetTotalQtdDinheiroPag(totQtdDinheiroPag);
      SetTotalValorDinheiroPag(totValorDinheiroPag.toFixed(2));

      SetTotalQtdReceived(totQtdRecebidos);
      SetTotalAmountReceived(totValorRecebidos.toFixed(2));
      setRowsFilter(newRowsFilter);
      setPage(0);
      setLoadingFilter(false);
    } catch (error) {
      console.error("ERROR PreviewReportERP filter:", error);
      setLoadingFilter(false);
    }
  }, [cnpj, fantasy, base, typePromoter, allRows]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <>
      <ModalLoading loading={loading || loadingFilter ? true : false} />

      <div>
        <div className="containerTable">
          <FilterReportERP />

          <Card className="card-default">
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size="medium"
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  classes={classes}
                  rowCount={rowsFilter.length}
                />
                <TableBody>
                  {[
                    ...rowsFilter.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    ),
                    {
                      Total: true,
                      Empresa: "TOTAL",

                      QtdPedidos: totalQtdPedidos,
                      ValorPedidos: totalValorPedidos,

                      QtdNFe: totalQtdNFe,
                      ValorNFe: totalValorNFe,

                      QtdNFSe: totalQtdNFSe,
                      ValorNFSe: totalValorNFSe,

                      QtdBoletoRec: totalQtdBoletoRec,
                      ValorBoletoRec: totalValorBoletoRec,

                      QtdCCreditoRec: totalQtdCCreditoRec,
                      ValorCCreditoRec: totalValorCCreditoRec,

                      QtdCDebitoRec: totalQtdCDebitoRec,
                      ValorCDebitoRec: totalValorCDebitoRec,

                      QtdDinheiroRec: totalQtdDinheiroRec,
                      ValorDinheiroRec: totalValorDinheiroRec,

                      QtdBoletoPag: totalQtdBoletoPag,
                      ValorBoletoPag: totalValorBoletoPag,

                      QtdCCreditoPag: totalQtdCCreditoPag,
                      ValorCCreditoPag: totalValorCCreditoPag,

                      QtdCDebitoPag: totalQtdCDebitoPag,
                      ValorCDebitoPag: totalValorCDebitoPag,

                      QtdDinheiroPag: totalQtdDinheiroPag,
                      ValorDinheiroPag: totalValorDinheiroPag,

                      QtdRecebidos: totalQtdReceived,
                      ValorRecebidos: totalAmountReceived,

                      QtdPagos: totalQtdtPaid,
                      ValorPagos: totalAmountPaid,
                    },
                  ].map((row, index) => {
                    return (
                      <TableRow hover tabIndex={-1} key={index}>
                        {[
                          { align: "left", name: "Empresa" },
                          { align: "left", name: "Base" },
                          { align: "center", name: "QtdClientes" },
                          { align: "center", name: "QtdFornecedores" },
                          { align: "center", name: "QtdProdutos" },

                          { align: "center", name: "QtdPedidos" },
                          { align: "left", name: "ValorPedidos" },

                          { align: "center", name: "QtdNFe" },
                          { align: "left", name: "ValorNFe" },

                          { align: "center", name: "QtdNFSe" },
                          { align: "left", name: "ValorNFSe" },

                          { align: "center", name: "QtdBoletoRec" },
                          { align: "left", name: "ValorBoletoRec" },

                          { align: "center", name: "QtdCCreditoRec" },
                          { align: "left", name: "ValorCCreditoRec" },

                          { align: "center", name: "QtdCDebitoRec" },
                          { align: "left", name: "ValorCDebitoRec" },

                          { align: "center", name: "QtdDinheiroRec" },
                          { align: "left", name: "ValorDinheiroRec" },

                          { align: "center", name: "QtdBoletoPag" },
                          { align: "left", name: "ValorBoletoPag" },

                          { align: "center", name: "QtdCCreditoPag" },
                          { align: "left", name: "ValorCCreditoPag" },

                          { align: "center", name: "QtdCDebitoPag" },
                          { align: "left", name: "ValorCDebitoPag" },

                          { align: "center", name: "QtdDinheiroPag" },
                          { align: "left", name: "ValorDinheiroPag" },

                          { align: "center", name: "QtdRecebidos" },
                          { align: "left", name: "ValorRecebidos" },

                          { align: "center", name: "QtdPagos" },
                          { align: "left", name: "ValorPagos" },
                        ].map((element, index) => {
                          const item = element.name;

                          const columnIndex = headCells.find(
                            (column) => column.name === item
                          );

                          if (
                            checkboxes[columnIndex.checkbox] ||
                            typeof checkboxes[columnIndex.checkbox] ===
                              "undefined"
                          ) {
                            if (row.Total) {
                              const columnMoney =
                                typeof item === "string" &&
                                item.indexOf("Valor") !== -1;

                              return (
                                <TableCell
                                  key={index}
                                  align={row[item] ? element.align : "center"}
                                  style={{ backgroundColor: "#d1d1d1" }}
                                >
                                  <label
                                    style={{ fontWeight: 550, fontSize: 16 }}
                                  >
                                    {row[item] && columnMoney
                                      ? MaskService.toMask("money", row[item])
                                      : row[item] || row[item] === 0
                                      ? row[item]
                                      : "-"}
                                  </label>
                                </TableCell>
                              );
                            }

                            return (
                              <TableCell
                                key={index}
                                align={row[item] ? element.align : "center"}
                              >
                                {row[item] &&
                                typeof item === "string" &&
                                item.indexOf("Valor") !== -1
                                  ? MaskService.toMask("money", row[item])
                                  : row[item] || "-"}
                              </TableCell>
                            );
                          } else return null;
                        })}
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={21} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={rowsFilter.length}
              rowsPerPage={rowsPerPage}
              page={page}
              labelRowsPerPage={"Linhas por página"}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Card>
        </div>
      </div>
    </>
  );
};

const PreviewReportERP = (props) => (
  <ReportERPContextProvider>
    <View {...props} />
  </ReportERPContextProvider>
);

export { PreviewReportERP };
